import * as z from "zod";

export const CameraValidationSchema = z.object({
  ipAddress: z.string().min(1, { message: "validation:required" }),
  location: z.string().min(1, { message: "validation:required" }),
  captureIntervalSeconds: z.number().optional(),
  username: z.string().optional(),
  password: z.string().optional(),
  apiEndpointPattern: z.string().optional(),
  contractId: z.string().optional(),
  wasteStreamTypeId: z.string().optional(),
  scheduleMode: z.string().optional(),
  scheduleIntervalSeconds: z.number().optional(),
  sensitivityThreshold: z.number().min(0).max(1).optional(),
});

export type CameraFormInput = z.infer<typeof CameraValidationSchema>;
